import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showModal } from 'Core/redux/main/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const { FORKLIFT_ADD_EDIT } = MODAL_TYPES;

const ForkliftTable = ({ activeLane }) => {
  const dispatch = useDispatch();
  const isLoading = false;

  const handleEditClick = record => {
    console.log('Opening modal from table with record:', record);
    console.log('Record ID from table:', record.id);
    console.log('Record forkliftId from table:', record.forkliftId);
    dispatch(showModal(FORKLIFT_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    // dispatch(deleteForklift(id));
  };

  // Sample data
  const data = [
    {
      id: 1,
      name: 'Forklift F-001',
      model: 'F-100',
      capacity: '2000kg',
      status: 'Active',
    },
    {
      id: 2,
      name: 'Forklift F-002',
      model: 'F-200',
      capacity: '3000kg',
      status: 'Active',
    },
  ];

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: 'Model',
      dataIndex: 'model',
      sorter: (a, b) => a.model.length - b.model.length,
    },
    {
      title: 'Capacity',
      dataIndex: 'capacity',
      sorter: (a, b) => a.capacity.length - b.capacity.length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (text, record) => (
        <div className="d-flex">
          <Link
            to="#"
            className="btn btn-sm btn-outline-primary me-2"
            onClick={() => handleEditClick(record)}
          >
            Edit
          </Link>
          <Link
            to="#"
            className="btn btn-sm btn-outline-danger"
            onClick={() => handleDeleteClick(record.id)}
          >
            Delete
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive">
      {isLoading && <LoadingSpinner />}
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        size="small"
      />
    </div>
  );
};

export default ForkliftTable;
